import { Injectable } from '@angular/core';

import { BaseHttpService } from './base-http.service';
import { environment } from '../../../environments/environment';
import { NotificationListType } from '../../shared/helpers/app.constants';
import { INotificationModel } from '../../shared/models/notification.model';



@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseHttpService {

  unseenCount() {
    return this.http.get<{ data: number }>(
      `${environment.apiBaseUrl}Notification/UnseenCount`,
    );
  }

  getAll(type: number = NotificationListType.Today) {
    return this.http.get<INotificationModel[]>(
      `${environment.apiBaseUrl}Notification/List?notificationType=${type}`,
    );
  }

  makeAsSeen(id: number) {
    return this.http.get(
      `${environment.apiBaseUrl}Notification/MakeAsSeen/${id}`,
    );
  }

  makeAsSeenAll() {
    return this.http.get(
      `${environment.apiBaseUrl}Notification/MakeAsSeenAll`,
    );
  }

  deleteAll() {
    return this.post(
      `${environment.apiBaseUrl}Notification/Delete`,
      null,
    );
  }

  delete(id: number) {
    return this.post(
      `${environment.apiBaseUrl}Notification/Delete/${id}`,
      null,
    );
  }
}
